exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".layout {\n  margin-top: 30px;\n  width: 100%;\n  min-height: 600px;\n}\n.layout .cus-layout {\n  background: transparent;\n}\n.layout .cus-layout .cus-sider {\n  height: 100%!important;\n  flex: 0 0 100px !important;\n  margin-right: 30px;\n  background-color: #fff;\n  border: 1px solid #e5e5e5;\n  width: 100px !important;\n  max-width: 100px !important;\n  min-width: 100px !important;\n}\n.layout .cus-layout .cus-content {\n  width: 80%;\n}\n.layout .cus-layout .cus-content-header {\n  background-color: #fff;\n  border: 1px solid #e5e5e5;\n  height: 60px;\n  padding-left: 30px;\n}\n.layout .cus-layout .cus-content-pages {\n  margin-top: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#3296FA"}}!./src/containers/layout/index.less
// module id = 677
// module chunks = 0